/**
 * LoginGate — ingreso con usuario del personal (2026-10-06).
 *
 * Reemplaza el PasswordGate cosmético (contraseña única validada en el navegador). La
 * contraseña la verifica el backend (/api/auth/login) y devuelve un token personal.
 */
import { useState } from 'react'
import { guardarSesion } from '../utils/sesion'
import { guardarSucursal } from '../hooks/useSucursal'

interface Props {
  onIngreso: () => void
}

export function LoginGate({ onIngreso }: Props) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [cargando, setCargando] = useState(false)

  async function ingresar(e: React.FormEvent) {
    e.preventDefault()
    setCargando(true)
    setError(null)
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), password }),
      })
      if (!res.ok) {
        let detalle = ''
        try {
          detalle = (await res.json())?.detail ?? ''
        } catch {
          /* sin cuerpo */
        }
        setError(detalle || 'No se pudo ingresar. Probá de nuevo.')
        setCargando(false)
        return
      }
      const datos = await res.json()
      guardarSesion(datos)
      // 21-oct: la cuenta de una sucursal (asistentefarmacia634) entra con su sucursal elegida
      if (datos?.sucursal?.id_und_neg) guardarSucursal(datos.sucursal)
      onIngreso()
    } catch {
      setError('Sin conexión con el servidor. Probá de nuevo.')
      setCargando(false)
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen" style={{ background: 'var(--color-bg)' }}>
      <form
        onSubmit={ingresar}
        className="w-full max-w-sm mx-4 p-8 rounded-lg border shadow-sm grid gap-4"
        style={{ background: 'var(--color-surface)', borderColor: 'var(--color-border)' }}
        aria-label="Ingreso"
      >
        <div className="text-center">
          <h1 className="text-lg font-semibold" style={{ color: 'var(--color-text)' }}>
            Asistente de farmacia
          </h1>
          <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
            Ingresá con tu usuario de Hipermaxi
          </p>
        </div>
        <label className="grid gap-1 text-sm" style={{ color: 'var(--color-text-muted)' }}>
          Usuario o email
          <input
            type="text"
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
              setError(null)
            }}
            autoFocus
            required
            className="w-full px-4 py-3 rounded border text-base"
            style={{ background: 'var(--color-surface-2)', borderColor: 'var(--color-border)', color: 'var(--color-text)' }}
          />
        </label>
        <label className="grid gap-1 text-sm" style={{ color: 'var(--color-text-muted)' }}>
          Contraseña
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
              setError(null)
            }}
            required
            className="w-full px-4 py-3 rounded border text-base"
            style={{ background: 'var(--color-surface-2)', borderColor: 'var(--color-border)', color: 'var(--color-text)' }}
          />
        </label>
        {error && (
          <p role="alert" className="text-sm" style={{ color: 'var(--color-danger)' }}>
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={cargando || !email || !password}
          className="w-full py-3 font-medium rounded text-white disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ background: 'var(--color-brand)' }}
        >
          {cargando ? 'Verificando…' : 'Ingresar'}
        </button>
      </form>
    </div>
  )
}
